import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { palette } from '../../../../system/styles/styles';
import { onChangeLoad } from '../../../../redux/reducer/loadReducer';
import { editPausedPlay } from '../../../../redux/actions/vacanciesActions';

const ContainerModal = styled.main`
  .k-dialog-titlebar {
    background-color: ${palette.green};
  }
  p {
    font-family: ${palette.nereg};
    font-size: 16px;
  }
  .close {
    background: none;
    color: ${palette.red};
    font-family: ${palette.nereg};
    border: none;
    font-size: 16px;
  }
  .save {
    background: ${palette.green};
    color: ${palette.white};
    font-family: ${palette.nereg};
    border: none;
    font-size: 16px;
  }
`;

const TitleContainer = () => {
  const { t } = useTranslation(['jobs']);
  return <h1 id="titleHeader"> {t('DeleteHeader')} </h1>;
};

const ModalPaused = (props) => {
  const { close } = props;
  const { t } = useTranslation(['jobs']);
  const dispatch = useDispatch();
  const { jobID } = useSelector((state) => state?.jobs?.editData);
  const onSavePaused = () => {
    dispatch(onChangeLoad(false));
    close();
    dispatch(editPausedPlay(jobID, false));
  };
  return (
    <ContainerModal>
      <Dialog title={<TitleContainer />} onClose={close}>
        <p>{t('ConfirmationMessage')}</p>
        <DialogActionsBar>
          <button type="button" className="k-button close" onClick={close}>
            {t('closed')}
          </button>
          <button type="button" className="k-button save" onClick={onSavePaused}>
            {t('pause')}
          </button>
        </DialogActionsBar>
      </Dialog>
    </ContainerModal>
  );
};

export default ModalPaused;

ModalPaused.propTypes = {
  close: PropTypes.func,
};

ModalPaused.defaultProps = {
  close: () => {},
};
